import { render, staticRenderFns } from "./AtomStatus.vue?vue&type=template&id=5b6fd0ca&"
import script from "./AtomStatus.vue?vue&type=script&lang=js&"
export * from "./AtomStatus.vue?vue&type=script&lang=js&"
import style0 from "./AtomStatus.vue?vue&type=style&index=0&id=5b6fd0ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports